import { apiFetch } from './ApiFetch';
import { getUserSessionCookie } from '../utils/SessionCookie';
import { BASE_URL } from './constants';
import { UsageEntry, WorkflowBreakdownResponse } from '../types/usage';

export const fetchUsageData = async (
  startDate: string,
  endDate: string
): Promise<UsageEntry[]> => {
  const userSessionToken = getUserSessionCookie();
  const res = await apiFetch(
    `${BASE_URL}/billing/usage?start_date=${startDate}&end_date=${endDate}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userSessionToken}`
      }
    }
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch usage data: ${res.status}`);
  }

  return res.json();
};

export const fetchMonthlyQuota = async (): Promise<number> => {
  const userSessionToken = getUserSessionCookie();
  const res = await apiFetch(`${BASE_URL}/billing/monthly-quota`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userSessionToken}`
    }
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch monthly quota: ${res.status}`);
  }

  return res.json();
};

export interface DailyStepUsageResponse {
  month: number;
  year: number;
  daily_usage: Array<{ date: string; steps: number }>;
}

export const fetchDailyStepUsage = async (
  month: number,
  year: number
): Promise<DailyStepUsageResponse> => {
  const userSessionToken = getUserSessionCookie();
  const params = new URLSearchParams({
    month: String(month),
    year: String(year)
  });
  const res = await apiFetch(
    `${BASE_URL}/billing/usage/daily?${params.toString()}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userSessionToken}`
      }
    }
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch daily usage: ${res.status}`);
  }

  return res.json();
};

export interface CreditsResponse {
  balance: number;
  org_id: string;
}

export const fetchCredits = async (): Promise<CreditsResponse> => {
  const userSessionToken = getUserSessionCookie();
  const res = await apiFetch(`${BASE_URL}/billing/credits`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${userSessionToken}`
    }
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch credits: ${res.status}`);
  }

  return res.json();
};
